export default __webpack_public_path__ + "static/media/IDCardPic.8c5816a0.jpg";